if (!customElements.get("lsg-accordion")) customElements.define("lsg-accordion", class LSGAccordion extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            toggle: ".js-lsg-accordion-toggle",
            content: ".js-lsg-accordion-content"
        };
        this.toggle = this.querySelectorAll(this.selectors.toggle);
        this.content = this.querySelectorAll(this.selectors.content);
        this.init();
    }

    init() {
        this.toggle.forEach(el => {
            el.addEventListener('click', () => {
                const isExpanded = el.getAttribute('aria-expanded') == 'true' ? true : false;
                this.toggle.forEach(item => {
                   item.setAttribute('aria-expanded', false);
                });
                el.setAttribute('aria-expanded', !isExpanded);
                this.content.forEach(item => {
                    item.classList.remove('is-open');
                });
                if (isExpanded == false) {
                    document.querySelector('#' + el.getAttribute('aria-controls')).classList.add('is-open');
                }
            })
        });
    }
});
